<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table 
        :headers="headers"
        :items="items"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        hide-default-footer
        disable-pagination
        height="340px"
      >
        <template v-slot:item.sub_account_money="{ item }">
          {{ $t("Global.money") }}
          {{ item.sub_account_money | formatMoney }}
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SubAccountAnalyses from "@/api/sub_account_analyses";

export default {
  name: "DialogShop",

  props: {
    value: Boolean,
    currentItem: Object,
  },
  computed: {
    headers() {
      return [
        {
          text: i18n.t("subAccountQuery.Detail.Fields.sub_account_type_str"),
          align: "start",
          sortable: false,
          value: "sub_account_type_str",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.account_name"),
          align: "start",
          sortable: false,
          value: "account_name",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.sub_account_money"),
          align: "start",
          sortable: false,
          value: "sub_account_money",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    items: []
  }),

  methods: {
    getOrderDetailFromAPI(orderDd) {
      SubAccountAnalyses.fetchOrderForSubAccount(orderDd).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.items = response.data.sub_account_details;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.value && this.currentItem) {
          this.getOrderDetailFromAPI(this.currentItem.order_id)
        }else {
          this.items = []
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>
